<template>
  <div>
    <h2 class="display-1 font-weight-bold mb-5">Client Registration Area</h2>
    <p class="my-4 text-justify">
      This Portal is currently available to Official Partners of Ctrax
    </p>
    <client-form @created="onSubmitted" />
  </div>
</template>

<script>
import ClientForm from '@/clients/createClientForm';

export default {
  components: { ClientForm },
  methods: {
    onSubmitted() {
      Notify.success('Registration was successful');
    },
  },
};
</script>
